import { render, staticRenderFns } from "./AccountProfileBoxShipments.vue?vue&type=template&id=42af9803&scoped=true&"
import script from "./AccountProfileBoxShipments.vue?vue&type=script&lang=js&"
export * from "./AccountProfileBoxShipments.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfileBoxShipments.vue?vue&type=style&index=0&id=42af9803&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af9803",
  null
  
)

export default component.exports